module.exports = __webpack_public_path__ + "img/type1.268632ca.png";